import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-172" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-primary/30 border-l-4 border-l-highlight bg-surface p-4 pr-10 text-foreground shadow-2xl shadow-foreground/15" aria-live="polite" data-id="element-173" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" aria-label="Dismiss notice" data-id="element-174" data-mp="1sgfs9qnz2eh0">
            <XIcon className="h-4 w-4" data-id="element-175" data-mp="1nfi8xar87edx" />
          </button>
          <div className="flex gap-3" data-id="element-176" data-mp="19pojorbt6s3o">
            <CheckCircle2Icon className="glow-led mt-0.5 h-5 w-5 shrink-0 text-highlight" aria-hidden="true" data-id="element-177" data-mp="19omwjohiqf5l" />
            <div data-id="element-178" data-mp="1ehpqhxq7jqmb">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-highlight" data-id="element-179" data-mp="1ei7ytsq59val">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-180" data-mp="14qbmbcnba2mu">
                Once your purchase is complete you receive the
                <br data-id="element-181" data-mp="qqamm0is918y" />
                <span className="font-bold text-foreground" data-id="element-182" data-mp="qrvjhwskkw9z">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-183" data-mp="vp403sy2ks94">Instant digital access by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}